"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.labels = void 0;
var labels = {
  he: {
    purchase_login_subTitle: 'בחירה מעולה, יש להתחבר קודם',
    purchase_default_btn_label: 'רוצה להצטרף',
    login_idm_btn: 'התחברות משרד החינוך',
    login_idm_alt: 'משרד החינוך',
    login_cet_btn: 'התחברות מטח',
    login_cet_alt: 'מטח',
    login_idm_desc: 'יש להזין מספר ת״ז של תלמיד/ה או מורה בלבד',
    login_welcome_title: 'ברוכים הבאים',
    login_welcome_subtitle: 'איך תרצו להתחבר?'
  },
  ar: {
    purchase_login_subTitle: 'اختيار ممتاز, يجب الشبك أوّلًا',
    purchase_default_btn_label: '​أريد الانضمام',
    login_idm_btn: 'تسجيل الدخول وزارة التربية',
    login_idm_alt: 'وزارة التربية',
    login_cet_btn: 'تسجيل الدخول مطاح',
    login_cet_alt: 'مطاح',
    login_idm_desc: 'استخدم/ي رقم هويّة التلميذ/ة أو المعلم/ة',
    login_welcome_title: 'مرحبا بك',
    login_welcome_subtitle: 'كيف تريد الشبك?'
  },
  en: {
    purchase_login_subTitle: 'Great! please log in first',
    purchase_default_btn_label: 'Get it now',
    login_idm_btn: 'התחברות משרד החינוך',
    login_idm_alt: 'משרד החינוך',
    login_cet_btn: 'התחברות מטח',
    login_cet_alt: 'CET',
    login_idm_desc: 'יש להזין מספר ת״ז של תלמיד/ה או מורה בלבד',
    login_welcome_title: 'ברוכים הבאים',
    login_welcome_subtitle: 'איך תרצו להתחבר?'
  }
};
exports.labels = labels;